import React from 'react';
import { formatMatchTime } from '../utils/time';

const LiveCouponPoster = ({ coupon, adminHidden = false }) => {
  const items = Array.isArray(coupon?.items) ? coupon.items.slice(0, 2) : [];

  return (
    <article className="live-coupon-poster">
      <img
        className="live-coupon-background"
        src="/live-coupon-template.png"
        alt="Canli kupon saha tasarimi"
      />
      <div className="live-coupon-overlay">
        <div className="live-coupon-bars">
          {items.map((item, index) => (
            <div className="live-coupon-bar" key={`${item.match?.fixtureId || index}-${item.selection}`}>
              <div className="live-coupon-bar-top">
                <span className="live-coupon-index">{index + 1}</span>
                <strong>
                  {item.match?.homeTeam?.name} - {item.match?.awayTeam?.name}
                </strong>
              </div>
              <div className="live-coupon-bar-bottom">
                <span>{item.selection}</span>
                <span>%{item.probability}</span>
                <small>{formatMatchTime(item.match?.date)}</small>
              </div>
            </div>
          ))}
        </div>

        <div className="live-coupon-footer">
          <span>Canli kupon guveni %{coupon?.confidenceScore || 0}</span>
          {adminHidden ? <strong>Admin tarafinda kapali</strong> : null}
        </div>
      </div>
    </article>
  );
};

export default LiveCouponPoster;
